import {Route, Switch} from 'react-router-dom';
import Register from '../rating/register/Register.component';
import Details from '../rating/operationalIndicator/Details.component';
import Assesment from '../rating/assessment/Assessment.component';
import MyStore from '../rating/graphic/MyStore.component';
import Answer from './answer/Answer.component';
import EvaluationItems from './register/EvaluationItems.component';


const Routes = () => {

    return (
        <Switch>
            <Route exact path="/avaliacao-loja" component={EvaluationItems} /> 
            <Route path="/avaliacao-loja/cadastrar-avaliacao" component={Register}/>
            <Route exact path="/avaliacao-loja/editar-avaliacao/:id" component={() => <Register disabled={true} /> }/> 
            <Route path="/avaliacao-loja/avaliacoes" component={Assesment} />
            <Route path="/avaliacao-loja/dashboard" component={MyStore} />
            <Route path="/avaliacao-loja/avaliacao/:idAssesment" component={Answer} />
            <Route component={() => <>NotFoundRedirect</>} />
        </Switch>
    );
}

export default Routes;